
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface AssessmentsSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export function AssessmentsSearch({ searchTerm, onSearchChange }: AssessmentsSearchProps) {
  return (
    <div className="flex items-center mb-4 sm:mb-6">
      <div className="relative w-full sm:w-96">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search assessments..."
          className="pl-8 min-h-[44px]"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
}
